const eventDatas = [
  {
    id: 1,
    title: "Zakovat 2023",
    date: "16.09.2023",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.",
    requirements: "11-sinf, Ingliz tilini bilishi",
  },
  {
    id: 2,
    title: "Futbol Chempionati",
    date: "16.10.2023",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.",
    requirements: "11-sinf, Ingliz tilini bilishi",
  },
  {
    id: 3,
    title: "Balli qizlar",
    date: "16.09.2023",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.",
    requirements: "11-sinf, Ingliz tilini bilishi",
  },
];

export default eventDatas;
